import type { UserRole } from "@/types";

/**
 * Rôles cantonnés au mobile terrain (pas d’accès web).
 * Opérateurs, chefs d’équipe et adjoints utilisent uniquement l’application mobile.
 */
export const ROLES_EXCLUDED_FROM_WEB: UserRole[] = [
  "operateur",
  "chef_equipe",
  "chef_equipe_adjoint",
];

export function canAccessWeb(role: UserRole | undefined): boolean {
  if (!role) return false;
  return !ROLES_EXCLUDED_FROM_WEB.includes(role);
}

export type Permission =
  | "users:any:crud"
  | "users:operators:crud"
  | "rtg:crud"
  | "blocks:crud";

// Mapping des rôles vers leurs permissions fonctionnelles
export const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
  admin: ["users:any:crud", "users:operators:crud", "rtg:crud", "blocks:crud"],
  chef_section: ["users:operators:crud"],
  control_room: ["rtg:crud", "blocks:crud"],
  chef_equipe: [],
  chef_equipe_adjoint: [],
  operateur: [],
};

export function hasPermission(
  role: UserRole | undefined,
  permission: Permission,
): boolean {
  if (!role) return false;
  return ROLE_PERMISSIONS[role]?.includes(permission) ?? false;
}
